import React from "react";
import { useParams } from "react-router-dom";
import CustomerEntryRoute from "./CustomerEntryRoute";

const LoadingStoreRoute = () => {
  const { caseId = "", conceptId = "" } = useParams<{
    caseId: string;
    conceptId: string;
  }>();
  const valid = /^\d+$/.test(caseId) && /^\d+$/.test(conceptId) &&
    Number.isSafeInteger(Number(caseId)) && Number(caseId) > 0 &&
    Number.isSafeInteger(Number(conceptId)) && Number(conceptId) > 0;
  const entry = valid
    ? { caseId: Number(caseId), conceptId: Number(conceptId) }
    : null;

  return <CustomerEntryRoute entry={entry} entryKey={`${conceptId}/${caseId}`} />;
};

export default LoadingStoreRoute;
